<script>
import Status from "../components/Modales/Status.vue";
import Spinner from "../components/Spinner.vue";
import MadeWith from "../components/MadeWith.vue";
import { mapActions } from "vuex";

export default {
  components: { Spinner, Status, MadeWith },

  data() {
    return {
      show_spinner: false,
      open_modal_status: false,
      modal_status_msg: "",
      modal_status: true,
      token: this.$route.params.token,
      key: this.$route.params.key,
      user_id: "",
      newPassword: "",
      newPasswordConfirm: "",
      errors: {
        newPassword: "",
        newPasswordConfirm: "",
      },
      showPassword: false,
      showPasswordConfirm: false,
      pageReady: false,
      publicPath: process.env.BASE_URL,
    };
  },

  mounted() {
    this.setUserIdFromToken();
    this.$nextTick(() => {
      setTimeout(() => {
        this.pageReady = true;
      }, 60);
    });
  },

  methods: {
    ...mapActions("loginModule", [
      "checkTokenRecoveryAction",
      "editPasswordRecuperacion",
    ]),
    ...mapActions("profileModule", ["editPasswordAction"]),

    validateForm() {
      let valid = true;
      this.errors.newPassword = "";
      this.errors.newPasswordConfirm = "";

      if (!this.newPassword) {
        this.errors.newPassword = "Campo requerido.";
        valid = false;
      } else if (this.newPassword.length < 6) {
        this.errors.newPassword =
          "La contraseña debe tener al menos 6 caracteres.";
        valid = false;
      } else {
        const strongRegex =
          /^(?=.*\d)(?=.*[!@#$%^&=/(){}[\].´\\\-_'¿?¡:+~*])(?=.*[a-z])(?=.*[A-Z]).+$/;
        if (!strongRegex.test(this.newPassword)) {
          this.errors.newPassword =
            "Debe tener mayúscula, minúscula, número y carácter especial.";
          valid = false;
        }
      }

      if (!this.newPasswordConfirm) {
        this.errors.newPasswordConfirm = "Campo requerido.";
        valid = false;
      } else if (this.newPassword !== this.newPasswordConfirm) {
        this.errors.newPasswordConfirm = "Las contraseñas no coinciden.";
        valid = false;
      }

      return valid;
    },

    async onChangePasswordSubmit() {
      if (!this.validateForm()) return;

      this.show_spinner = true;
      const editPasswordRes = await this.editPassword();

      if (editPasswordRes) {
        this.toastEditPasswordSuccess();
        this.redirectToLogin();
      } else if (editPasswordRes === null) {
        this.toastEditPasswordError();
      } else if (editPasswordRes === false) {
        this.toastEditPasswordInvalid();
      }

      this.show_spinner = false;
    },

    async setUserIdFromToken() {
      this.show_spinner = true;
      const payload = {
        token: this.token,
        uuid: this.key,
      };
      const check = await this.checkTokenRecoveryAction(payload);
      if (check) {
        this.user_id = check.id_usuario;
      } else {
        this.open_modal_status = true;
        this.modal_status = false;
        if (check === false) {
          this.modal_status_msg = "La URL ingresada es inválida.";
        } else if (check === null) {
          this.modal_status_msg =
            "Ha ocurrido un problema. Por favor intenta nuevamente.";
        }
      }
      this.show_spinner = false;
    },

    async editPassword() {
      const encodedNewPassword = btoa(btoa(btoa(this.newPassword)));
      const payload = {
        id_usuario: this.user_id,
        password: encodedNewPassword,
        token: this.token,
        uuid: this.key,
      };
      const res = await this.editPasswordRecuperacion(payload);
      return res === null ? res : res.password;
    },

    closeStatus() {
      this.open_modal_status = false;
      if (this.modal_status === false) {
        this.redirectToLogin();
      }
    },

    redirectToLogin() {
      this.$router.push({ name: "Login" });
    },

    toastEditPasswordSuccess() {
      this.$toast.open({
        message: "Cambio de contraseña exitoso.",
        type: "success",
        duration: 5000,
        position: "top-right",
      });
    },
    toastEditPasswordError() {
      this.$toast.open({
        message:
          "Error al cambiar la contraseña. Por favor intenta nuevamente.",
        type: "error",
        duration: 5000,
        position: "top-right",
      });
    },
    toastEditPasswordInvalid() {
      this.$toast.open({
        message:
          "La contraseña debe contener al menos 6 caracteres, minúscula, mayúscula, un dígito y un carácter especial.",
        type: "error",
        duration: 5000,
        position: "top-right",
      });
    },
  },
};
</script>

<template>
  <div class="logintoken">
    <img
      class="logintoken__dog"
      :src="publicPath + 'imgs/login/perro_volador.png'"
      alt="Dog"
    />
    <div class="logintoken__center">
      <!-- Logo -->
      <div class="logintoken__logo reveal" :class="{ in: pageReady }">
        <img
          :src="publicPath + 'imgs/kaik.svg'"
          alt="Logo KAIK"
          class="logintoken__logo-img"
          height="36"
        />
      </div>

      <!-- Tarjeta -->
      <div
        class="logintoken__card reveal reveal-delay-1"
        :class="{ in: pageReady }"
      >
        <small class="logintoken__card-label">RECUPERAR ACCESO</small>
        <h2 class="logintoken__card-title">Nueva contraseña</h2>

        <form
          class="logintoken__form"
          @submit.prevent="onChangePasswordSubmit"
          novalidate
        >
          <!-- Input nueva contraseña -->
          <div class="logintoken__field">
            <label class="logintoken__label">Nueva contraseña</label>
            <div
              class="logintoken__input-wrap"
              :class="{ 'logintoken__input-wrap--error': errors.newPassword }"
            >
              <svg
                class="logintoken__input-icon"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <rect
                  x="3"
                  y="11"
                  width="18"
                  height="11"
                  rx="2"
                  stroke="#9ca3af"
                  stroke-width="1.8"
                />
                <path
                  d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
                  stroke="#9ca3af"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />
              </svg>
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="newPassword"
                placeholder="Mínimo 6 caracteres"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="logintoken__eye"
                @click="showPassword = !showPassword"
                :aria-label="showPassword ? 'Ocultar' : 'Mostrar'"
              >
                <svg
                  v-if="!showPassword"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                  />
                </svg>
                <svg
                  v-else
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
                  <line
                    x1="1"
                    y1="1"
                    x2="23"
                    y2="23"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
            <p v-if="errors.newPassword" class="logintoken__error-msg">
              {{ errors.newPassword }}
            </p>
          </div>

          <!-- Input confirmar contraseña -->
          <div class="logintoken__field">
            <label class="logintoken__label">Confirmar contraseña</label>
            <div
              class="logintoken__input-wrap"
              :class="{
                'logintoken__input-wrap--error': errors.newPasswordConfirm,
              }"
            >
              <svg
                class="logintoken__input-icon"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M9 12l2 2 4-4"
                  stroke="#9ca3af"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
                  stroke="#9ca3af"
                  stroke-width="1.8"
                />
              </svg>
              <input
                :type="showPasswordConfirm ? 'text' : 'password'"
                v-model="newPasswordConfirm"
                placeholder="Repite la contraseña"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="logintoken__eye"
                @click="showPasswordConfirm = !showPasswordConfirm"
                :aria-label="showPasswordConfirm ? 'Ocultar' : 'Mostrar'"
              >
                <svg
                  v-if="!showPasswordConfirm"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                  />
                </svg>
                <svg
                  v-else
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
                  <line
                    x1="1"
                    y1="1"
                    x2="23"
                    y2="23"
                    stroke="#9ca3af"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
            <p v-if="errors.newPasswordConfirm" class="logintoken__error-msg">
              {{ errors.newPasswordConfirm }}
            </p>
          </div>

          <!-- Requisitos de seguridad -->
          <ul class="logintoken__requirements">
            <li :class="{ met: newPassword.length >= 6 }">
              Mínimo 6 caracteres
            </li>
            <li :class="{ met: /[A-Z]/.test(newPassword) }">Una mayúscula</li>
            <li :class="{ met: /[0-9]/.test(newPassword) }">Un número</li>
            <li
              :class="{
                met: /[!@#$%^&=/(){}[\].\u00b4\\\-_'\u00bf?\u00a1:+~*]/.test(
                  newPassword,
                ),
              }"
            >
              Un carácter especial
            </li>
          </ul>

          <button
            type="submit"
            class="btn btn-custom-color-blue border-round-50 mw-100 mt-3"
          >
            Actualizar contraseña
          </button>
        </form>

        <a class="logintoken__back" @click="redirectToLogin()">
          Volver al inicio de sesión
        </a>
      </div>

      <!-- Decoraciones -->
      <img
        :src="publicPath + 'imgs/login/icon_l.svg'"
        alt=""
        class="logintoken__icon-l"
        aria-hidden="true"
      />
      <img
        :src="publicPath + 'imgs/login/icon_c.svg'"
        alt=""
        class="logintoken__deco-c"
        aria-hidden="true"
      />
    </div>

    <!-- Footer -->
    <div class="logintoken__footer">
      <MadeWith />
    </div>

    <Status
      v-if="open_modal_status"
      :msg="modal_status_msg"
      :status="modal_status"
      @close="closeStatus()"
      style="z-index: 100"
    />
    <Spinner v-if="show_spinner" />
  </div>
</template>
